import { render, staticRenderFns } from "./TodoView.vue?vue&type=template&id=738a0885&scoped=true"
import script from "./TodoView.vue?vue&type=script&lang=js"
export * from "./TodoView.vue?vue&type=script&lang=js"
import style0 from "./TodoView.vue?vue&type=style&index=0&id=738a0885&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738a0885",
  null
  
)

export default component.exports